
import React, { lazy, Suspense } from 'react';
import './Career.css';
import { getStoredData } from "../../json/fetchData.js";

// ✅ Lazy load the components
const AllIntroTemplate = lazy(() => import("../../components/AllIntroTemplate/AllIntroTemplate.js"));
const ContentModel = lazy(() => import("../../components/ContentModel/ContentModel.js"));
const CareerHiring = lazy(() => import('../../components/CareerHiring/CareerHiring.js'));

const Career = () => {
  const totalData = getStoredData();
  const data = totalData ? totalData["25"] : {};

  return (
    <div>
      {/* ✅ Wrap lazy-loaded components in Suspense */}
      <Suspense fallback={<p>Loading intro...</p>}>
        <AllIntroTemplate image={data.Image} title={data.Title} page={totalData ? totalData["0"] : {}} />
      </Suspense>
      
      <Suspense fallback={<p>Loading content...</p>}>
        <ContentModel data={totalData ? totalData["25"] : {}} />
      </Suspense>

      <Suspense fallback={<p>Loading career section...</p>}>
        <CareerHiring />
      </Suspense>
    </div>
  );
};

export default Career;
